
import Vue from 'vue';

Vue.directive('field-visible', {
  bind: function (el, b) {
    if (b.value !== true) {
      $(el).addClass("invisible-field");
    }
  },
  update: function (el, b) {
    if (b.value === true) {
      $(el).removeClass("invisible-field");
    } else {
      $(el).addClass("invisible-field");
    }
  }
});
